"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePrimaryAddressLocation = void 0;
var _usePrimaryAddressQuery = require("../api/usePrimaryAddressQuery");
var _useGeocodingSearch = require("./useGeocodingSearch");
/**
 * @obsolete Can be dropped later when flat selection UI is used in all markets
 * and/or the merged map & list UI switch is enabled everywhere.
 */
const usePrimaryAddressLocation = ({
  isActive
}) => {
  const {
    isPrimaryAddressLoading: isStep1Loading,
    primaryAddress
  } = (0, _usePrimaryAddressQuery.usePrimaryAddressQuery)(isActive);

  // TODO: There is now a bug in the /system/ajax/DeliverySelection/GetPrimaryAddress endpoint.
  // It returns the more detailed data in the city property, less detailed generic data in address.
  // This should be swapped & then also the props used here in step 2 & 3.
  const isStep2Active = Boolean(primaryAddress?.city) && !isStep1Loading;
  const {
    data: step2Result,
    isLoading: isStep2Loading
  } = (0, _useGeocodingSearch.useGeocodingSearch)({
    isActive: isStep2Active,
    searchTerm: primaryAddress?.city ?? ''
  });
  const isStep3Active = Boolean(primaryAddress?.address) && !isStep1Loading && !isStep2Loading && !step2Result;
  const {
    data: step3Result,
    isLoading: isStep3Loading
  } = (0, _useGeocodingSearch.useGeocodingSearch)({
    isActive: isStep3Active,
    searchTerm: primaryAddress?.address ?? ''
  });
  return {
    isPrimaryAddressLoading: isStep1Loading || isStep2Loading || isStep3Loading,
    primaryAddress,
    primaryAddressLocation: step2Result ?? step3Result ?? undefined
  };
};
exports.usePrimaryAddressLocation = usePrimaryAddressLocation;